import React, { FC, useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu, Avatar, LayoutProps, Image } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import { RouterProps } from 'router/routeUrl';
import styles from './index.module.less';
import classnames from 'classnames';
import logo from 'assets/imgs/logo_white.png';
import logoBlack from 'assets/imgs/logo_black.png';
import iconMenu from 'assets/imgs/menu.png';
import iconMenuBlack from 'assets/imgs/menu_black.png';
import iconMenuLose from 'assets/imgs/menu_close.png';

import MenuLayer from 'components/MenuLayer';
import { useScroll } from 'ahooks';

const sideLayout = false; // layout布局，默认 false 为顶部横向菜单，设置 true 为侧边栏菜单
const { Header, Content, Sider } = Layout;

interface BaseLayoutProps extends LayoutProps {
  className?: string;
  menu?: RouterProps[];
}

const BaseLayout: FC<BaseLayoutProps> = (props) => {
  let location = useLocation();
  const { className, children, menu = [] } = props;
  const [selectedKeys, setSelectedKeys] = useState<string>();
  const [collapsed, changeCollapsed] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(false);

  const scroll = useScroll(document);

  const isWhiteTheme = useMemo(() => {
    return location.pathname.includes('/info/');
  }, [location]);

  useEffect(() => {
    setSelectedKeys(location.pathname);
  }, [location]);

  useEffect(() => {
    if (showMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showMenu]);

  return sideLayout ? (
    // 菜单侧边布局
    <Layout className={classnames(styles.sideLayout, className)}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <Link className={styles.logo} to="/home">
          <Image preview={false} src="" />
        </Link>
        <Menu className={styles.headerMenu} mode="inline" selectedKeys={[]}>
          {menu
            ?.filter((item) => item.menuName)
            ?.map((item) => (
              <Menu.Item key={item.path} icon={item.menuIcon}>
                <Link to={item.path}>{item.menuName}</Link>
              </Menu.Item>
            ))}
        </Menu>
      </Sider>
      <Layout className={styles.siteLayout}>
        <Header className={styles.header} style={{ padding: 0 }}>
          {collapsed ? (
            <MenuUnfoldOutlined className={styles.icon} onClick={() => changeCollapsed(false)} />
          ) : (
            <MenuFoldOutlined className={styles.icon} onClick={() => changeCollapsed(true)} />
          )}
          <Avatar src="https://guanwang-1301026175.cos.ap-beijing.myqcloud.com/ee/2021090617011328459f8598a-ee3b-4d3c-baf5-bee72dc2d85d.png" />
        </Header>
        <Content>{children}</Content>
      </Layout>
    </Layout>
  ) : (
    // 菜单顶部布局
    <div
      className={classnames(styles.baseLayoutContainer, {
        [styles['info-page']]: isWhiteTheme,
      })}
    >
      <Layout className={classnames(styles.baseLayout, className)}>
        <Header
          className={classnames(styles.header, {
            [styles.isScroll]: scroll && scroll.top > 20 && !showMenu && isWhiteTheme,
          })}
        >
          <div className={styles.headerContent}>
            <Link className={styles.logo} to="/home" onClick={() => setShowMenu(false)}>
              <Image preview={false} src={isWhiteTheme && !showMenu ? logoBlack : logo} width="2.16rem" />
            </Link>

            <div className={classnames('flex cursor-pointer', styles.menu)} onClick={() => setShowMenu(!showMenu)}>
              {showMenu ? null : <span>Menu</span>}
              {/* {isWhiteTheme && <Image preview={false} src={showMenu ? iconMenuLose : iconMenuBlack} height=".75rem" />} */}

              {!showMenu && <Image preview={false} src={isWhiteTheme ? iconMenuBlack : iconMenu} width=".75rem" />}

              {showMenu && (
                <div className="flex flex-x-center" style={{ width: '.75rem', height: '.75rem' }}>
                  <Image preview={false} src={iconMenuLose} height=".34rem" />
                </div>
              )}
            </div>
          </div>
        </Header>

        <MenuLayer
          showMenuLayer={showMenu}
          onMenuItemClick={() =>
            setTimeout(() => {
              setShowMenu(false);
            }, 200)
          }
        />

        <Content>{children}</Content>
      </Layout>
    </div>
  );
};

export default BaseLayout;
